import { createFileRoute } from '@tanstack/react-router';

import { DashboardPage } from '@/features/admin/dashboard-page';

export const Route = createFileRoute('/_app/')({
  component: DashboardPage,
});
